import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	DialogActions,
	DialogContent,
	Dialog,
	DialogTitle,
	Grid,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from "@mui/material";

import { ValidateEmail, ValidatePhone } from "../Common/helpers";
export default function AmbassadorInviteProspectDialog(props) {
	const [form, setForm] = useState({});
	const [complete, setComplete] = useState(false);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};
	useEffect(() => {
		if (window.location.href.startsWith("http://localhost") && form.email === undefined) {
			setForm({
				...form,
				email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
				fname: "Guill",
				lname: "Besse" + Math.floor(Math.random() * 1000000) + " (PRS)",
				phone1: "0637574129",
			});
		}
	}, []);

	useEffect(() => {
		setComplete(
			ValidateEmail(form.email) &&
			form.lname.length > 0 &&
			form.fname.length > 0 &&
			ValidatePhone(form.phone1) &&
			["M", "Mme"].includes(form.gender)
		);
	}, [form]);
	const handleInvite = () => {


		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...form, uid: props.state.params.uid }),
		};
		fetch("/api/cca6cdfcc17b4ad6b2bc2d19b3b68b09/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						console.log(res);
						window.location.reload();
						//nextStep();
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Inviter un acquéreur
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Grid container spacing={2} style="max-width: 500px;">
					<Grid item xs={3}>
						<RadioGroup row aria-label="gender" name="gender" defaultValue={form.gender} onChange={handleChange}>
							<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
							<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
						</RadioGroup>
					</Grid>
					<Grid item xs={9}>
						<TextField
							id="fname"
							name="fname"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Prénom *"
							fullWidth
							margin="dense"
							size="small"
							value={form.fname}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							id="lname"
							name="lname"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Nom *"
							fullWidth
							margin="dense"
							size="small"
							value={form.lname}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							id="phone1"
							name="phone1"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Téléphone"
							fullWidth
							margin="dense"
							size="small"
							value={form.phone1}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							id="email"
							name="email"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 10,
							}}
							placeholder="Email *"
							fullWidth
							margin="dense"
							size="small"
							value={form.email}
							onChange={handleChange}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
					<Box style="width: 100%">
						<Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
							<Box>
								<Button onClick={handleClose}>Annuler</Button>
							</Box>
							<Box>
								<Button variant="contained" disabled={!complete} onClick={handleInvite}>
									Inviter
								</Button>
							</Box>{" "}
						</Box>
					</Box>
				</Box>
			</DialogActions>
		</Dialog >
	);
}
